// Warna yang maknanya sama tapi ditulis di lebih dari satu file.
// Kembarannya src/assets/css/tokens.css; designTokens.check.mjs jaga keduanya tetep sama.
// Nol import biar bisa dijalanin node langsung.

// Dipakai OperationModePanel, CompareOperationMode, sama DonutChart.
export const OPERATION_MODE_PALETTE = ['#667eea', '#764ba2', '#f093fb', '#f5576c', '#4facfe', '#00f2fe', '#43e97b', '#38f9d7'];

// Chip status kapal, cuma kepake dari CSS. Warna dot-nya ada di shipStatus.js (CLUSTER_COLORS).
export const SHIP_STATUS_CHIP = {
  online: { bg: '#d7f0d8', fg: '#38ac3d' },
  offline: { bg: '#ffe4e4', fg: '#f24848' },
  'no-gps': { bg: '#e5e7eb', fg: '#6b7280' },
  'no-sensor': { bg: '#ffedd5', fg: '#ea580c' },
};
